import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21c8286e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "draft-board" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "pick-number" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "pos" }

import { Ref,  nextTick, onMounted, ref, watch } from 'vue'
import ffWebsiteAPI from '@/services/ff-website-api';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyDraft',
  props: ['year'],
  setup(__props) {

const props = __props

_useCssVars(_ctx => ({
  "122f4292": (teams.value)
}))


const draftdata: Ref<{draftpicks_set: Array<any>} | null> = ref(null);
const draftPicksByRound: Ref<any> = ref(null) 
const teams: Ref<any> = ref(null) 
const draftOrder: Ref<any> = ref(null) 


onMounted(() => {
  ffWebsiteAPI.ready = new Promise(resolve => {
      ffWebsiteAPI.resolver = resolve;
  });
  ffWebsiteAPI.resolver(1)
  fetchDraft();
});


async function fetchDraft() {
    try {
      const response = await ffWebsiteAPI.getDraft(props.year);
      draftdata.value = response[0]; 
      if (draftdata.value != null) {
        draftPicksByRound.value = sortPicksIntoRounds(draftdata.value.draftpicks_set)
        teams.value = Number(draftPicksByRound.value[0].length)
        draftOrder.value = draftdata.value.draftpicks_set.slice(0, teams.value)
        //draftOrder.value = draftPicksByRound.value[0].slice(0, teams.value)
      }
      await nextTick()
    }
    catch (e) {
      console.log(e)
    }
}


watch(() => props.year, () => {
  draftdata.value = {'draftpicks_set': []}
  draftPicksByRound.value = null
  draftOrder.value = null
  fetchDraft();
})


const sortPicksIntoRounds = (draftPicks: any[]): any[] => {
  const roundsMap = new Map<number, any[]>();

  // Group draft picks by round number
  draftPicks.forEach(pick => {
    const roundNum = pick.round_num;
    if (!roundsMap.has(roundNum)) {
      roundsMap.set(roundNum, []);
    }
    var round = roundsMap.get(roundNum)
    if (round != undefined) {
      round.push(pick);
    }
  });

  roundsMap.forEach((value: Array<any>, key: number) => {
    if (isEvenRound(key+1)) {
      const reverseRound = value.reverse();
      roundsMap.set(key, reverseRound)
    }
  });

  const roundsArray = Array.from(roundsMap.values());

  roundsArray.sort((a, b) => a[0].round_num - b[0].round_num);
  return roundsArray;
  }

const isEvenRound = (roundNum: number) => {
  return roundNum % 2 !== 0;
}


// const checkClass = (index: number, index2: number) => {
//   if (isEvenRound(index+1)) {
//     if (index2==11) {
//       return 'ldown'
//     }
//     else {
//       return 'ltor'
//     }
//   }
//   else {
//     if (index2==0) {
//       return 'fdown'
//     }
//     else {
//       return 'rtol'
//     }
//   }
// }



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", null, _toDisplayString(__props.year) + " Draft", 1),
    _createElementVNode("body", null, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(draftOrder.value, (pick) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "team",
            key: pick.pick_num
          }, [
            _createTextVNode(_toDisplayString(pick.team.first_name) + " ", 1),
            _hoisted_2,
            _createTextVNode(" " + _toDisplayString(pick.team.last_name), 1)
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(draftPicksByRound.value, (round, round_index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: round_index }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(round, (pick, pick_index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["pick", {'pick-wr': pick.player.position==='WR', 
                                  'pick-rb': pick.player.position==='RB',
                                  'pick-te': pick.player.position==='TE',
                                  'pick-qb': pick.player.position==='QB',
                                  'pick-k': pick.player.position==='K',
                                  'pick-d': pick.player.position==='DEF'}]),
                key: pick.pick_num
              }, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(pick.round_num) + "." + _toDisplayString(isEvenRound(Number(round_index)+1) ? Number(pick_index)+1 : teams.value-Number(pick_index)) + " (" + _toDisplayString(pick.pick_num) + ")", 1),
                _createTextVNode(_toDisplayString(pick.player.first_name), 1),
                _hoisted_4,
                _createTextVNode(_toDisplayString(pick.player.last_name) + " ", 1),
                _createElementVNode("span", _hoisted_5, _toDisplayString(pick.player.position), 1)
              ], 2))
            }), 128))
          ], 64))
        }), 128))
      ])
    ])
  ], 64))
}
}

})